import { FiscalDataManager } from "@/components/fiscal-data-manager.jsx";

export default function LiasseFiscale() {
  return (
    <div className="p-6 space-y-6">
      <div>
        <h1 className="text-3xl font-bold tracking-tight">Liasse Fiscale</h1>
        <p className="text-muted-foreground mt-2">
          Gérez et personnalisez l'extraction des données fiscales
        </p>
      </div>

      <FiscalDataManager />
    </div>
  );
}
